import { useTenantLocalStorage } from '@hooks/useLocalStorage';

export function usePipelineVizEnabled() {
    return useTenantLocalStorage<boolean>('labs-pipeline-viz-enabled', false);
}
